import { redirect } from "@tanstack/react-router";
import type { ServicePackageEnum } from "@/lib/enums/service-package-enum";
import type { UserContext } from "@/lib/interfaces/user-context";

export const validatePackageAccess = ({
  user,
  packageService,
}: {
  user: UserContext;
  packageService: ServicePackageEnum;
}): void => {
  const userHasAccess = hasAccess(user, packageService);

  if (userHasAccess) {
    return;
  }

  redirectToAssistMenu();
};

export const validateDeactivatedPackageAccess = ({
  user,
  packageService,
}: {
  user: UserContext;
  packageService: ServicePackageEnum;
}): void => {
  const PackageService = user.pacotesServicos.find(
    (x) => x.codPacoteServicos === packageService.valueOf(),
  );

  const isDeactivated = PackageService && Boolean(PackageService.dataDesativacao);

  if (!isDeactivated) {
    redirectToAssistMenu();
  }
};

const hasAccess = (user: UserContext, packageService: ServicePackageEnum): boolean => {
  return Boolean(
    user.pacotesServicos.find((x) => x.codPacoteServicos === packageService.valueOf()),
  );
};

const redirectToAssistMenu = (): void => {
  redirect({ to: "/settings/assist", throw: true });
};
